import type React from "react";
import {memo} from "react";

import SelectGeneric from "../SelectGeneric";

import {useDayOptions} from "./useDayOptions";

type Props = {
    value?: number;
    isDisabled?: boolean;
    onChange: (value: number) => void;
};

const SelectDay: React.FC<Props> = ({value = 0, onChange, isDisabled}) => {
    const dayOptions = useDayOptions();

    return (
        <SelectGeneric
            isClearable={false}
            isDisabled={isDisabled}
            options={dayOptions}
            placeholder="Days..."
            testID="select-days"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectDay);
